<template>
  <div class="part-item projectFeature">
    <p class="part-title">实验教学项目特色
    </p>
    <div class="part-content">
      <p class="fangsong">（体现虚拟仿真实验项目建设的必要性及先进性、教学方式方法、评价体系及对传统教学的延伸与拓展等方面的特色情况介绍）</p>
      <span class="content-title">实验方案设计思路：</span>
      <div
        class="content-text"
        v-if="!formInfo.feature_design"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.feature_design"
        v-html="formInfo.feature_design"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">教学方法：</span>
      <div
        class="content-text"
        v-if="!formInfo.feature_tech"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.feature_tech"
        v-html="formInfo.feature_tech"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">评价体系：</span>
      <div
        class="content-text"
        v-if="!formInfo.feature_appraise"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.feature_appraise"
        v-html="formInfo.feature_appraise"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">传统教学的延伸与拓展：</span>
      <div
        class="content-text"
        v-if="!formInfo.feature_more"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.feature_more"
        v-html="formInfo.feature_more"
      ></div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ExperimentalFeatures',
  props: ['expId'],
  components: {
  },
  data () {
    return {
      formInfo: {}
    }
  },
  methods: {

    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
      }).catch((error) => {
        console.log(error)
      })
    }

  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
</style>
